import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import type React from "react";
import { Button } from "./button";

interface SideSheetProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  title?: string;
  width?: number;
  className?: string;
}

export function SideSheet({
  children,
  open,
  onClose,
  title,
  width = 360,
  className,
}: SideSheetProps) {
  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Backdrop */}
          <motion.div
            // @ts-expect-error -- idk
            as="div"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-black/50"
            onClick={onClose}
          />

          {/* Sheet */}
          <motion.div
            // @ts-expect-error -- idk
            as="div"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", damping: 30, stiffness: 300 }}
            className={cn(
              "fixed right-0 top-0 z-50 flex h-full flex-col border-l border-border bg-background shadow-lg",
              className,
            )}
            style={{ width }}
          >
            <div className="flex items-center justify-between border-b border-border p-4">
              {title && <h2 className="text-lg font-semibold">{title}</h2>}
              <Button
                variant="ghost"
                size="icon"
                className="ml-auto"
                onClick={onClose}
              >
                <X className="h-4 w-4" />
                <span className="sr-only">Close</span>
              </Button>
            </div>

            <div className="flex-1 overflow-auto p-4">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
